import classNames from 'classnames';
import { Button, ButtonGroup } from 'reactstrap';

export enum FilterState {
  ON,
  OFF,
  DISABLED
}

export interface FilterOption {
  value: FilterState, 
  change: (newValue: FilterState) => void
}

function FilterProjectToggles({
  favorite, active
}: {
  favorite: FilterOption,
  active: FilterOption
}) {

  let triToggle = (item: FilterOption) => {
    let newValue;
    switch(item.value) {
      case FilterState.ON: newValue = FilterState.OFF; break;
      case FilterState.OFF: newValue = FilterState.DISABLED; break;
      case FilterState.DISABLED: newValue = FilterState.ON; break;
    }
    item.value = newValue
    item.change(newValue)
  }

  let triLabel = (state: FilterState, textOn : String, textOff: String) => {
    switch(state) {
      case FilterState.ON: return textOn;
      case FilterState.OFF: return textOff;
      case FilterState.DISABLED: return "All";
    }
  } 


  return (
    <ButtonGroup className='w-100'>
      <Button block={true} active={favorite.value === FilterState.ON || favorite.value === FilterState.OFF} 
              color={favorite.value === FilterState.DISABLED ? 'text-disabled': 'warning'} 
              onClick={() => {triToggle(favorite)}}>
        <i className={classNames({
          'fa-fw fa-heart me-2 ': true,
          'text-danger': favorite.value !== FilterState.DISABLED,
          'fas': (favorite.value === FilterState.ON),
          'far': (favorite.value === FilterState.OFF || favorite.value === FilterState.DISABLED),
        })} />
        {triLabel(favorite.value, 'Favorite', 'Non-Favorite')}
      </Button>
      <Button block={true} active={active.value === FilterState.ON || active.value === FilterState.OFF} 
              color={active.value === FilterState.DISABLED ? 'text-disabled': 'primary'} 
              onClick={() => {triToggle(active)}}>
        <i className={classNames({
          'fa-fw fa-lightbulb me-2': true,
          'text-warning': active.value !== FilterState.DISABLED,
          'fas': (active.value === FilterState.ON),
          'far': (active.value === FilterState.OFF || active.value === FilterState.DISABLED),
        })} />
        {triLabel(active.value, 'Active', 'Inactive')}
      </Button>
    </ButtonGroup>
  );
}

export default FilterProjectToggles;
